"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatConfigServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const trans_1 = require("../../../../common/translations/trans");
class ChatConfigService extends client_1.RWSService {
    constructor() {
        super(...arguments);
        this.chatConfigOverrides = {};
        this.chatTeasers = {
            TEASER_CTA_LABEL: 'chat.teaser.cta.label'.t(),
            HEADING_CHAT: 'chat.heading.chat'.t(),
            HEADING_ASK: 'chat.heading.ask'.t(),
            DEFAULT_PROMPTS: [
                { description: 'chat.teaser.default.prompt1.description'.t(), text: 'chat.teaser.default.prompt1.text'.t() },
                { description: 'chat.teaser.default.prompt2.description'.t(), text: 'chat.teaser.default.prompt2.text'.t() },
                { description: 'chat.teaser.default.prompt3.description'.t(), text: 'chat.teaser.default.prompt3.text'.t() }
            ]
        };
        this.mainConfig = {
            BOT_TYPING_EFFECT_INTERVAL: 50,
            IS_DEFAULT_PROMPTS_ENABLED: true,
            DISPLAY_DEFAULT_PROMPTS_BUTTON: 'chat.config.display.default.prompts.button'.t(),
            CHAT_MESSAGES: [],
            CHAT_BUTTON_LABEL_TEXT: 'chat.config.button.label.text'.t(),
            CHAT_CANCEL_BUTTON_LABEL_TEXT: 'chat.config.cancel.button.label.text'.t(),
            CHAT_VOICE_BUTTON_LABEL_TEXT: 'chat.config.voice.button.label.text'.t(),
            CHAT_VOICE_REC_BUTTON_LABEL_TEXT: 'chat.config.voice.rec.button.label.text'.t(),
            CHAT_INPUT_NEWLINE_HELPER: 'chat.config.input.newline.helper'.t(),
            AUTOCOMPLETE_STYLES_HELPER: 'chat.config.autocomplete.styles.helper'.t(),
            AUTOCOMPLETE_PROJECTS_HELPER: 'chat.config.autocomplete.projects.helper'.t(),
            AUTOCOMPLETE_KNOWLEDGE_HELPER: 'chat.config.autocomplete.knowledge.helper'.t(),
            LIVE_CHAT_BUTTON_LABEL_TEXT: 'chat.config.live_chat.button.label.text'.t(),
            ADD_KDB_BUTTON_LABEL_TEXT: 'chat.config.add.kdb.button.label.text'.t(),
            CHAT_INPUT_PLACEHOLDER: 'chat.config.input.placeholder'.t(),
            USER_IS_BOT: 'chat.config.user.is.bot'.t(),
            RESET_BUTTON_LABEL_TEXT: 'chat.config.reset.button.label.text'.t(),
            RESET_BUTTON_TITLE_TEXT: 'chat.config.reset.button.title.text'.t(),
            RESET_CHAT_BUTTON_TITLE: 'chat.config.reset.chat.button.title'.t(),
            COPY_RESPONSE_BUTTON_LABEL_TEXT: 'chat.config.copy.response.button.label.text'.t(),
            COPIED_SUCCESSFULLY_MESSAGE: 'chat.config.copied.successfully.message'.t(),
            FOLLOW_UP_QUESTIONS_LABEL_TEXT: 'chat.config.follow.up.questions.label.text'.t(),
            SHOW_THOUGH_PROCESS_BUTTON_LABEL_TEXT: 'chat.config.show.thought.process.button.label.text'.t(),
            HIDE_THOUGH_PROCESS_BUTTON_LABEL_TEXT: 'chat.config.hide.thought.process.button.label.text'.t(),
            LOADING_INDICATOR_TEXT: 'chat.config.loading.indicator.text'.t(),
            LOADING_TEXT: 'chat.config.loading.text'.t(),
            API_ERROR_MESSAGE: 'chat.config.api.error.message'.t(),
            INVALID_REQUEST_ERROR: 'chat.config.invalid.request.error'.t(),
            THOUGHT_PROCESS_LABEL: 'chat.config.thought.process.label'.t(),
            SUPPORT_CONTEXT_LABEL: 'chat.config.support.context.label'.t(),
            CITATIONS_LABEL: 'chat.config.citations.label'.t(),
            CITATIONS_TAB_LABEL: 'chat.config.citations.tab.label'.t(),
            IS_CUSTOM_BRANDING: false,
            BRANDING_URL: '#',
            BRANDING_LOGO_ALT: 'chat.config.branding.logo.alt'.t(),
            BRANDING_HEADLINE: 'chat.config.branding.headline'.t(),
            SHOW_CHAT_HISTORY_LABEL: 'chat.config.show.chat.history.label'.t(),
            HIDE_CHAT_HISTORY_LABEL: 'chat.config.hide.chat.history.label'.t(),
            CHAT_MAX_COUNT_TAG: '{MAX_CHAT_HISTORY}',
            CHAT_HISTORY_FOOTER_TEXT: 'chat.config.chat.history.footer.text'.t(),
            WEB_SEARCH_CHECKBOX_LABEL: 'chat.config.web.search.checkbox.label'.t(),
            DEEP_SEARCH_CHECKBOX_LABEL: 'chat.config.deep.search.checkbox.label'.t(),
            REASONING_LABEL: 'chat.config.reasoning.label'.t(),
            ADV_PROMPT_CHECKBOX_LABEL: 'chat.config.adv.prompt.checkbox.label'.t(),
            AUTOCOMPLETE_STYLE_SELECTED: 'chat.config.autocomplete.style.selected'.t(),
            AUTOCOMPLETE_PROJECT_SELECTED: 'chat.config.autocomplete.project.selected'.t(),
            AUTOCOMPLETE_KNOWLEDGE_SELECTED: 'chat.config.autocomplete.knowledge.selected'.t(),
            TOOLTIPS: {
                CHAT_PICK_KDB: 'config.tooltips.chat.pick.kdb'.t(),
                CHAT_SETTINGS: 'config.tooltips.chat.settings'.t(),
                SEND_PROMPT: 'config.tooltips.send.prompt'.t(),
                PROMPT_WITH_MICROPHONE: 'config.tooltips.prompt.with.microphone'.t(),
                ATTACH_FILE_TO_PROMPT: 'config.tooltips.attach.file.to.prompt'.t(),
                CANCEL_REQUEST: 'config.tooltips.cancel.request'.t(),
            },
            MODAL_TITLES: {
                CHAT_SETTINGS: 'modal.settings.title'.t(),
            },
            AUTOTALK_LABEL: 'chat.config.autotalk.label'.t(),
        };
    }
    /**
     * Initialize language setting
     */
    initializeLanguage(storageService) {
        const language = storageService.get(trans_1.langKey);
        if (ChatConfigService.VERBOSE) {
            console.log('[ChatConfigService] Initializing language from storage:', language);
        }
        this.chatConfigOverrides.language = language;
    }
    /**
     * Update chat overrides
     */
    updateOverrides(updates) {
        if (ChatConfigService.VERBOSE) {
            console.log('[ChatConfigService] Updating chat overrides:', updates);
            console.log('[ChatConfigService] Previous overrides:', this.chatConfigOverrides);
        }
        this.chatConfigOverrides = { ...this.chatConfigOverrides, ...updates };
        if (ChatConfigService.VERBOSE) {
            console.log('[ChatConfigService] New overrides:', this.chatConfigOverrides);
        }
    }
    /**
     * Get serialized overrides
     */
    getOverrides() {
        return JSON.stringify(this.chatConfigOverrides);
    }
    getOverridesData() {
        return this.chatConfigOverrides;
    }
    /**
     * Get serialized teasers
     */
    getTeasers() {
        return JSON.stringify(this.chatTeasers);
    }
    /**
     * Get serialized config
     */
    getConfig() {
        return JSON.stringify(this.mainConfig);
    }
    /**
     * Reset configuration to defaults
     */
    reset() {
        this.chatConfigOverrides = {};
    }
}
exports.ChatConfigServiceInstance = ChatConfigService;
ChatConfigService.VERBOSE = false;
exports.default = ChatConfigService.getSingleton();
